import $ from 'jquery';
import dialogService from "./dialogService";
import { getMsg, isEmpty, isNotEmpty } from '../../util/util';
import rootScope from '../../store/rootScopeStore';

/**
* エラーメッセージを設定する処理
* 
* @param {any} dispatch 
* @returns 
*/
const addMsgBase = (errCd, keyName, itemName, errCdParam) => {

    // エラーコードが空の場合処理しない
    if (isEmpty(errCd)) return;
    // エラーメッセージ取得
    let msg = getMsg(errCd, errCdParam);
    // 表示するエラーメッセージの生成
    let errMsg = isEmpty(itemName) ? msg : `${itemName}:` + msg;
    // エラー通知パネル表示メッセージの初期化（オブジェクト生成を関数で行う）
    if (!rootScope.errors["panelmsg"]) {
        rootScope.errors["panelmsg"] = {};
    }
    rootScope.errors["panelmsg"][keyName] = errMsg;
    // エラーコード保持用変数の初期化（オブジェクト生成を関数で行う）
    if (!rootScope.errors["errCd"]) {
        rootScope.errors["errCd"] = {};
    }
    rootScope.errors["errCd"][keyName] = errCd;

    // エラーメッセージ（画面上部）
    rootScope.errors["currentErrorMsg"] = errMsg;
    rootScope.errors["length"] = Object.keys(rootScope.errors["panelmsg"]).length;

    // 画面の切り替え時に初期化された場合はエラーメッセージを表示しない
    if (isEmpty(rootScope.errors.length) || rootScope.errors.length <= 0) return;
    // エラー判別フラグ
    rootScope.errors["isErrorForPanel"] = true;
    rootScope.errors["isErrorForAlert"] = true;

}

/**
* エラーメッセージを削除する処理
* 
* @param {any} dispatch 
* @returns 
*/
const delMsgBase = (keyName) => {
    // エラーメッセージの設定がない場合は処理しない
    if (isEmpty(rootScope.errors) || isEmpty(rootScope.errors.panelmsg)) return;
    // キーに紐づくエラーメッセージを取得
    const panelMsg = rootScope.errors.panelmsg[keyName];
    // キーに紐づくエラーメッセージが存在しない場合処理しない
    if (isEmpty(panelMsg)) return;

    if (!!panelMsg) {
        if (rootScope.errors.currentErrorMsg === panelMsg) {
            // エラーアラートメッセージ初期化
            rootScope.errors.currentErrorMsg = "";
            rootScope.errors.isErrorForAlert = false;
        }
        // エラー通知パネルから削除する
        delete rootScope.errors.panelmsg[keyName];
    }
    delete rootScope.errors.errCd[keyName];
    // エラーの合計数
    rootScope.errors.length = Object.keys(rootScope.errors.panelmsg).length;
    // エラーがなくなった場合
    if (rootScope.errors.length <= 0) {
        // エラー通知とパネルの表示をoffにする
        rootScope.setErrors("isErrorForPanel", false)
    } else {
        prevMsg();
    }
}

const prevMsg = () => {

    if (rootScope.errors.length <= 0) return;
    // エラーが残っている場合、前回発生したエラーを表示しフォーカスを戻す
    const key = Object.keys(rootScope.errors.panelmsg)[rootScope.errors.length - 1];
    rootScope.errors.currentErrorMsg = rootScope.errors.panelmsg[key];
    rootScope.errors.isErrorForAlert = true;
}

// 照会画面が表示されているかどうか判別する（照会画面の場合trueを返す）
const isModalDialog = () => {
    return $(".modal-dialog").is(":visible");
}

/**
 * エラーメッセージキー生成
 * 
 * @param {any} name 
 * @returns 
 */
const getErrMsgKey = (name) => {
    return rootScope.currentPage + name;
}

/**
* エラーメッセージ追加：ディレクティブから設定する場合の呼び出し元
* 
* @param {any} dispatch 
* @returns 
*/
const addMsgLabel = (errCd, props, errCdParam) => {

    // 照会画面でのエラーの場合はダイアログにて表示する
    if (isModalDialog()) {
        // エラーダイアログが表示されている場合は設定しない
        if ($(".error-dialog").is(":visible")) return;
        // 照会画面でエラーメッセージを表示する場合
        dialogService.okDialog(errCd, getMsg(errCd), errCdParam, null);
        // 初期化（false=メッセージを表示する）TODO
        // isErrMsgDisp = false;
    } else {
        // FromToプロパティがある場合はFromのname値を利用する
        const attrName = props.fromValue ? props.id : props.name;
        const labelName = $("label[for='" + attrName + "']").text();
        // labelの設定がない場合に開発者が特定できるようname属性値を設定する
        const dispItemName = isNotEmpty(labelName) ? labelName : props.name;
        addMsgBase(errCd, props.name, dispItemName, errCdParam);
    }
}

/**
* エラーメッセージ追加：nameからメッセージキーを自動生成
* 
* @param {any} dispatch 
*/
const addMsgKey = (errCd, name, errCdParam) => {

    const errMsgKey = getErrMsgKey(name);
    const labelName = $("label[for='" + name + "']").text();
    addMsgBase(errCd, errMsgKey, labelName, errCdParam);
}

/**
* エラーメッセージ削除：ディレクティブから設定する場合の呼び出し元
* 
* @param {any} dispatch 
* @returns 
*/
const delMsgLabel = (props) => {

    // 照会画面のエラーはダイアログで表示するためメッセージ削除処理をスキップする
    if (isModalDialog()) return;
    delMsgBase(props.name);
}

// エラーメッセージ削除：nameからメッセージキーを自動生成
const delMsgKey = (name) => {
    let errMsgKey = getErrMsgKey(name);
    errMsgService.delMsg(errMsgKey);
}

// エラーメッセージ全削除
const clearAllMsg = () => {
    // オブジェクトを初期化する
    rootScope.errors = {};
    // 必須入力エラー時のcssの適用を削除
    $('input[name]').removeClass("error-place");
}

const hasMsg = (keyName) => {
    if (isNotEmpty(rootScope.errors.panelmsg) && !!rootScope.errors.panelmsg[keyName]) {
        return true;
    }
    return false;
}

const errExistsCheck = (callback, params, okBtnFunc, promisObj) => {
    const check = () => {
        if (isEmpty(rootScope.errors.length) || rootScope.errors.length === 0) {
            callback(params);
        } else {
            dialogService.okDialog("EWEB0010", null, [rootScope.errors.length], okBtnFunc);
        }
    }
    if (isEmpty(promisObj) || isEmpty(promisObj.list)) {
        if (isNotEmpty(promisObj)) promisObj.list = null;
        check();
    } else {
        Promise.all(promisObj.list).then(function () {
            promisObj.list = null;
            check();
        });
    }
}


const errMsgService = {
    addMsgBase,
    addMsgLabel,
    addMsgKey,
    delMsgBase,
    delMsgLabel,
    delMsgKey,
    delMsg: delMsgBase,
    clearAllMsg,
    hasMsg,
    getErrMsgKey,
    errExistsCheck
}

export default errMsgService;